import { defineMessages } from 'react-intl';
export default defineMessages({
    averageOverThePeriod: {
        id: 'charts.averageOverThePeriod',
        defaultMessage: 'Average over the period'
    },
    calendarView: {
        id: 'charts.calendarView',
        defaultMessage: 'Calendar view'
    },
    charts: {
        id: 'charts.charts',
        defaultMessage: 'Charts'
    },
    chartView: {
        id: 'charts.chartView',
        defaultMessage: 'Chart view'
    },
    comparison: {
        id: 'charts.comparison',
        defaultMessage: 'Comparison'
    },
    customizeComparisonMetrics: {
        id: 'charts.customizeComparisonMetrics',
        defaultMessage: 'Customize metrics'
    },
    customizeComparisonMetricsDescription: {
        id: 'charts.customizeComparisonMetricsDescription',
        defaultMessage: 'Drag items to reorder your comparison metrics. Tap the eye icon to show or hide metrics.'
    },
    maxOverThePeriod: {
        id: 'charts.maxOverThePeriod',
        defaultMessage: 'Maximum over the period'
    },
    measureToDisplay: {
        id: 'charts.measureToDisplay',
        defaultMessage: 'Measure to display'
    },
    minMaxRange: {
        id: 'charts.minMaxRange',
        defaultMessage: 'Min / Max'
    },
    noDataForThisPeriod: {
        id: 'charts.noDataForThisPeriod',
        defaultMessage: 'No data for this period'
    },
    /*
     * The on/off row at the top of the comparison sheet: it shows or hides the
     * earlier period on the chart. Sheet chrome, so validate-required-strings
     * fails on an empty translation (an empty one would speak English).
     */
    observations: {
        id: 'charts.observations',
        defaultMessage: 'Observations'
    },
    observedTemperature: {
        id: 'charts.observedTemperature',
        defaultMessage: 'Observed temperature'
    },
    showComparison: {
        id: 'charts.showComparison',
        defaultMessage: 'Show comparison'
    },
    stationComparison: {
        id: 'charts.stationComparison',
        defaultMessage: 'Station comparison'
    },
    stationComparisonDescription: {
        id: 'charts.stationComparisonDescription',
        defaultMessage: 'Compare historical weather data with another station'
    },
    sumOverThePeriod: {
        id: 'charts.sumOverThePeriod',
        defaultMessage: 'Cumulated over the period'
    },
    viewAsList: {
        id: 'charts.viewAsList',
        defaultMessage: 'List'
    },
    viewAsPeriods: {
        id: 'charts.viewAsPeriods',
        defaultMessage: 'Periods'
    }
});
